module.exports = {
    "collectionLabel": `Forslag`
};


//# sourceMappingURL=nb-NO.main.js.map
